import React, { useEffect, useState } from "react";
import "../components/Trending.css";
import "../components/Spinner.css";

export default function Trending() {
  const [deals, setDeals] = useState([]);
  const [error, setError] = useState(null);

  const API_BASE = process.env.REACT_APP_API_BASE;

  useEffect(() => {
    async function fetchDeals() {
      try {
        const res = await fetch(
          "https://3savkcd25d3tidkh3tsvm4oixe0hlhrj.lambda-url.us-east-2.on.aws/"
        );
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }
        const items = await res.json();

        const mapped = items.map((item) => {
          let highResImg;
          if (item.product_name == item.product_name.toUpperCase()) {
            highResImg = item.image_url.replace(
              /w=\d+(?:&sh=\d+)?/g,
              "w=800&sh=800"
            );
          } else {
            highResImg = item.image_url.replace(
              /sw=\d+&sh=\d+/g,
              "sw=800&sh=800"
            );
          }
          return {
            link: item.link,
            imgUrl: highResImg,
            name: item.product_name,
            originalPrice: item.original_price,
            currentPrice: item.current_price,
          };
        });

        setDeals(mapped);
      } catch (e) {
        console.error(e);
        setError(e.toString());
      }
    }

    fetchDeals();
  }, [API_BASE]);

  return (
    <section className="trending">
      <h2 className="trending_title">Trending Deals</h2>

      {error && <p className="trending_error">Error loading deals: {error}</p>}

      <div className="trending_grid">
        {deals.length > 0
          ? deals.map((item, idx) => (
              <a key={idx} className="trending_card">
                <img
                  src={item.imgUrl}
                  alt={item.name}
                  className="trending_image"
                />
                <div className="trending_info">
                  <a
                    href={item.link}
                    className="item-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <p className="trending_name">{item.name}</p>
                  </a>
                  <p className="trending_prices">
                    <span className="trending_original">
                      ${item.originalPrice}
                    </span>
                    <span className="trending_current">
                      ${item.currentPrice}
                    </span>
                  </p>
                </div>
              </a>
            ))
          : !error && (
              <div className="trending_loading_container">
                <div className="spinner" />
                <p className="trending_loading_message">
                  Retrieving sales data — please check back in a few minutes.
                </p>
              </div>
            )}
      </div>
    </section>
  );
}
